class ContactListViewMode
  constructor: (properties) ->
    for name, value of @defaultProperties
      if properties.hasOwnProperty name
        @[name] = properties[name]
      else
        @[name] = value

  defaultProperties:
    action_step: false # show action step column?
    actions_dropdown: true # show actions dropdown ?
    anywhere_select: false
    anywhere_select_action: 'none'
    business: 'column' # below-name / column / none
    flow: true # show current flow column?
    status: true
    stage: true
    name_go_to_show: true # clicking the name goes to contact/:id?
    group: false
    user: true # show user miniature?
    change_url_on_filter: true
    allow_update_stage: true
    remove_action: 'destroy-contact'
    show_checkbox: true
    edit_button: false
    delete_button: false
    initialized_contact_icon: false
    show_filters: true
    show_status_updated_at_column: false
    number_of_tags: 10
    user_filter: true
    tags_filter: true
    lost_reason: true
    group_filter: false
    label_clear_filter: true
    show_stage_updated_at_column: false
    link_open_bar: false
    only_picture_miniature: false
    show_flow: false #is this the show flow page?
    show_selections: true
    show_created_at_column: false

ContactListViewModes = {}
ContactListViewModes.index = new ContactListViewMode {}

ContactListViewModes.picker = new ContactListViewMode(
                                actions_dropdown: false
                                anywhere_select: true # TODO: make it true
                                anywhere_select_action: 'check'
                                flow: false
                                name_go_to_show: false
                                change_url_on_filter: false
                                allow_update_stage: false
                                number_of_tags: 8
                                user_filter: false
                                group_filter: true
                                show_selections: false
                                label_clear_filter: false
                              )

ContactListViewModes.flow = new ContactListViewMode(
                                action_step: true
                                flow: false
                                name_go_to_show: true
                                user: false
                                remove_action: 'remove-from-flow'
                                link_open_bar: true
                                show_flow: true
                                show_checkbox: false
                                show_selections: false
                              )

ContactListViewModes.flow_edit = new ContactListViewMode {
                                flow: false
                                name_go_to_show: false
                                user: false
                                actions_dropdown: false
                                status: false
                                stage: false
                                group: true
                                show_checkbox: false
                                edit_button: true
                                delete_button: true
                                initialized_contact_icon: true
                                show_selections: false
                                user_filter: false
                                status: true
                                stage: true
                                lost_reason: false
                                tags_filter: true
                                show_show_filters: true
                              }

ContactListViewModes.single_picker = new ContactListViewMode(
                                          actions_dropdown: false
                                          anywhere_select: true
                                          anywhere_select_action: 'emit-selected'
                                          flow: false
                                          name_go_to_show: false
                                          change_url_on_filter: false
                                          allow_update_stage: false
                                          show_checkbox: false
                                          number_of_tags: 8
                                          user_filter: true
                                          show_selections: false
                                          label_clear_filter: false
                                        )

ContactListViewModes.group = new ContactListViewMode {
                                user: false
                                name_go_to_show: true
                                user_filter: false
                                show_selections: false
                                show_checkbox: false
                              }

ContactListViewModes.group_picker = new ContactListViewMode {
                                user: false
                                name_go_to_show: false
                                actions_dropdown: false
                                show_selections: false
                                label_clear_filter: false
                                user_filter: false
                              }

ContactListViewModes.paused_contacts = new ContactListViewMode(
                                             business: 'below-name'
                                             actions_dropdown: true
                                             anywhere_select_action: 'none'
                                             flow: false
                                             name_go_to_show: true
                                             change_url_on_filter: false
                                             allow_update_stage: true
                                             show_checkbox: false
                                             show_filters: false
                                             show_status_updated_at_column: true
                                             link_open_bar: true
                                             show_selections: false
                                           )

ContactListViewModes.last_opportunities = new ContactListViewMode(
                                           actions_dropdown: false
                                           anywhere_select_action: 'none'
                                           flow: false
                                           name_go_to_show: true
                                           change_url_on_filter: false
                                           allow_update_stage: true
                                           show_checkbox: false
                                           show_filters: false
                                           show_status_updated_at_column: true
                                           link_open_bar: true
                                           show_selections: false
                                         )

ContactListViewModes.business_contacts = new ContactListViewMode(
                                             business: 'none'
                                             user: true
                                             show_created_at_column: true
                                             actions_dropdown: true
                                             anywhere_select: 'none'
                                             flow: false
                                             name_go_to_show: true
                                             change_url_on_filter: false
                                             allow_update_stage: true
                                             show_checkbox: false
                                             show_filters: false
                                             show_status_updated_at_column: false
                                             link_open_bar: true
                                             show_selections: false
                                             number_of_tags: 3
                                             only_picture_miniature: true
                                           )

class ContactGroupListViewMode
  constructor: (properties) ->
    for name, value of @defaultProperties
      if properties.hasOwnProperty name
        @[name] = properties[name]
      else
        @[name] = value

  defaultProperties:
    actions_dropdown: true # show actions dropdown ?
    statistics: true #show statistics columns
    user: true # show user miniature?
    contacts_count: true # show contacts count column
    allow_update_stage: false
    filters: true
    import_action: false
    remove_action: 'destroy-contact-group'
    anywhere_select: false

ContactGroupListViewModes = {}

ContactGroupListViewModes.index = new ContactGroupListViewMode {}

ContactGroupListViewModes.import = new ContactGroupListViewMode {
                                actions_dropdown: false
                                user: false
                                statistics: false
                                filters: false
                                import_action: true
                                anywhere_select: true
                              }

module.exports = {
  methods:
    contactListViewModes: ->
      ContactListViewModes

    contactGroupListViewModes: ->
      ContactGroupListViewModes
}



// WEBPACK FOOTER //
// ./src/helpers/contacts/list_view_modes.coffee